import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { BannerAreaComponent } from './banner-area.component';

@Directive({
  selector: '[closeDescriptionOnClick]',  
})

export class CloseDescriptionOnClick {
   constructor(private _elementRef : ElementRef , private bannerAreaComponent : BannerAreaComponent) {
    }

    @Output()
    public closeDescriptionOnClick = new EventEmitter();

    /* To capture all clicks on the host element of the document and 
       check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {   
            this.bannerAreaComponent.descVisibility = true;
            this.bannerAreaComponent.priceVisibility = false;
            this.bannerAreaComponent.checkVisibility = false;  
            this.bannerAreaComponent.icon ="gray";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/banner-area/close-description-on-click.ts